import {
  CalculateStripePricingBreakdownRequest,
  STRIPE_PRICING_BREAKDOWN_API,
} from '@aloft/toolkit-shared';

import { useCallback } from 'react';

import { useCalculateStripePricingBreakdown } from '../../../hooks/api/toolkitComponents.ts';
import { useToaster } from '../../../hooks/useToaster/useToaster.tsx';

export function useCalculatePricingBreakdown() {
  const toast = useToaster();

  const { mutateAsync, isLoading, isError } = useCalculateStripePricingBreakdown({
    onError: (error) => {
      console.error('Could not calculate pricing breakdown.', JSON.stringify(error, null, 2));
      toast({
        id: 'calculate-pricing-breakdown-error',
        type: 'error',
        title: 'Could not get price information',
        body: [
          'Sorry, there was an error getting our latest price information.',
          'Please ensure your billing address or promo code is valid and entered properly, then try again.',
        ].join(' '),
      });
    },
  });

  const calculatePricingBreakdown = useCallback(
    async (params: CalculateStripePricingBreakdownRequest) => {
      const response = await mutateAsync({
        body: STRIPE_PRICING_BREAKDOWN_API.POST.REQUEST.BODY.parse({
          priceID: params.priceID,
          address: params.address,
          isTrial: params.isTrial,
          promotionCode: params.promotionCode,
        }),
      });
      return STRIPE_PRICING_BREAKDOWN_API.POST.RESPONSE.parse(response);
    },
    [mutateAsync],
  );

  return {
    calculatePricingBreakdown,
    isLoading,
    isError,
  };
}
